export const PUBLIC_HEADER_MESSAGE =
  "These are public read-only sample datasets. You can switch to your private workspace.";

//parameters for data page filters
export const PAGE_PARAMETER = "page";
export const PAGE_SIZE_PARAMETER = "page_size";
export const VERTEX_CONTEXT = "vc";
export const VERTEX_ID = "v";
export const VERTEX_TYPE = "vt";
export const ENTITY_TYPE_PARAMETER = "t";
export const SEARCH_TEXT_PARAMETER = "q";
export const LABELS_PARAMETER = "labels";
export const FOLDER_PARAMETER = "folder";
export const ISSUE_TYPE_PARAMETER = "issue-types";
export const USER_TAGS_PARAMETER = "user-tags";
export const GRANULARITY_PARAMETER = "granularity";
export const CAPTION_PARAMETER = "caption";
export const ISSUE_CONFIDENCE = "issue_confidence";
export const DUPLICATE_THRESHOLD = "duplicate_threshold";
export const UNIQUENESS_SCORE_PARAMETER = "uniqueness_score";
export const METADATA_SOURCES_PARAMETER = "metadata_sources";
export const SAVED_VIEW_PARAMETER = "saved_view";
export const SEARCH_TEXT_THRESHOLD_PARAMETER = "search_text_threshold";
export const OBJECT_ID_QUERY_PARAMETER = "object_id";
export const VQL_PARAMETER = "vql";
export const SEED_PARAMETER = "seed";
export const FLOW_PARAMETER = "flow";
export const REVIEW_PARAMETER = "review";
export const MANUAL_REVIEW_FLOW = "manual_review_flow";
export const REVIEW_TAB_PARAMETER = "review_tab";
export const LABEL_CLASS_PARAMETER = "labelId";
export const FLAT_RESPONSE_PARAMETER = "flat_response";
export const AUTOMATIC_FLAT_RESPONSE_PARAMETER = "auto_flat_response";
export const VIDEO_ID_PARAMETER = "video_id";
export const VIDEO_CLUSTER_ID_PARAMETER = "video_cluster_id";
export const VERTEX_SIMILARITY = "vs";
export const SEMANTIC_RELEVANCE_THRESHOLD = "semantic_relevance_threshold";

//parameter to save data page number when moving into cluster page.
export const DATA_PAGE_PARAMETER = "d_page";

export const LOADING_OR_ERROR_CARD_DIMENSION_NUMBER = -99999;

//invitation token
export const INVITATION_TOKEN_PARAMETER = "ref";

export const FREE_ACCOUNT_PLAN_DEFAULT_LIMIT = 10000;

export const enum PipelineType {
  NORMAL = "NORMAL",
  ENRICHED = "ENRICHED",
  BIG = "BIG",
  BIG_ENRICHED = "BIG_ENRICHED",
}

export const FETCH_ENRICHMENT_PROGRESS_INTERVAL = 1000 * 30;

export const LOCAL_ENRICHMENT_MODEL_DATA =
  "local_enrichment_model_selection_data";
